/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var SharepointIcon = createIcon("SharepointIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M12.256 13.53a6.14 6.14 0 10-6.034-7.28",
    stroke: _color,
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4 7.483a5.63 5.63 0 01-1.028 11.162 5.628 5.628 0 01-5.056-3.154",
    stroke: _color,
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.372 18.39a4.349 4.349 0 11-8.68-.4M1.938 6.366h9.38c.518 0 .938.42.938.938v9.38c0 .518-.42.938-.938.938h-9.38A.938.938 0 011 16.684v-9.38c0-.518.42-.938.938-.938Z",
    stroke: _color,
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.602 14.936a3.12 3.12 0 01-1.076-.188 2.19 2.19 0 01-.86-.56 1.608 1.608 0 01-.416-.932h1.008c.064.293.219.517.464.672.245.152.537.228.876.228.357 0 .66-.07.908-.212.248-.141.372-.347.372-.616a.63.63 0 00-.272-.548 1.905 1.905 0 00-.716-.292l-1.064-.232c-.432-.088-.773-.259-1.024-.512-.248-.253-.375-.59-.38-1.012-.003-.35.09-.653.276-.912a1.8 1.8 0 01.768-.604A2.729 2.729 0 016.574 9c.48 0 .884.079 1.212.236.328.157.576.367.744.628.17.259.259.544.264.856H7.81c-.035-.344-.168-.584-.4-.72a1.563 1.563 0 00-.824-.208c-.32 0-.59.073-.812.22a.697.697 0 00-.328.612.6.6 0 00.184.456c.125.115.359.212.7.292l1.04.232c.323.064.583.161.78.292a1.432 1.432 0 01.656.94c.037.17.056.332.056.484 0 .301-.092.575-.276.82-.184.243-.445.436-.784.58-.339.144-.739.216-1.2.216Z",
    fill: _color
  }));
}, {
  "replaceColor": true
});